import { createSelector } from "reselect";

import Store, { RootState } from "../../../redux/store";
import { TResourceType } from "../../../types/resources/resources.types";

import { CommentsState } from "../types/comments-state/comments-state.interface";
import * as actions from "./comments.actions";

export const getCommentsState = (state: RootState): CommentsState => state.commentsState;

export const getComments = createSelector(
  getCommentsState,
  (commentsState: CommentsState) => commentsState.searchResults
);

export const isLoading = createSelector(getCommentsState, (state: CommentsState) => state.loading);

export function fetchComments(resourceId: number, resourceType: TResourceType) {
  Store.dispatch(actions.fetch(resourceId, resourceType));
}

export function postComment(resourceId: number, resourceType: TResourceType, comment: string) {
  Store.dispatch(actions.post(resourceId, resourceType, comment));
}

export function resetState() {
  Store.dispatch(actions.resetState());
}
